function init_girls_game(girlData,game_happy_max){
    
    var main=$(".place.girls"),
    gameCanvas=main.find("#girlGameJsCanvas"),
    ghostCanvas=main.find("#girlGhostJsCanvas"),
    book=main.find("#bookGameJS"),
    startCanvas=book.find("#bookGameStartJS"),
    startImgCanvas=book.find("#bookGameStartImgJS"),
    gameCell=main.find("#gameCellJS"),
    animCanvas=main.find("#girlAnimJsCanvas"),
    startIndex=_moduleTimeHandler.getNewIndex(),
    gameIndex=_moduleTimeHandler.getNewIndex();
    var pointsStart=[],pointsGame=[], gameHowlong=30;
    var gameState={good:0,bad:0,happy:0,good_max:0,good_all:0,bad_all:0,ended_all:0};
    function gameDuring(){
        var gameConf=[
            {good_min:2,good_max:2,bad_min:1,bad_max:1,cost:100},
            {good_min:3,good_max:3,bad_min:1,bad_max:1,cost:300},
            {good_min:4,good_max:5,bad_min:3,bad_max:3,cost:600},
            {good_min:3,good_max:3,bad_min:1,bad_max:1,cost:300},
            
        ],gameConfBase={good_min:1,good_max:2,bad_min:1,bad_max:1,cost:150},stat=0;
        var girl_center=$.takeGirlPositionConf(girlData.girl_id,girlData.level).center;
        girl_center[1]=780-girl_center[1];
        var step_arr={},howlong=0,howlong_max=(gameHowlong-5)*1000,state=0,step=50;
        for(howlong=0;howlong<=howlong_max;howlong+=100){
            state++;
            step+=mt_rand(10,12);
            if(stat==0){
                if(gameConf.length){
                    stat=gameConf.shift();
                }
                else{
                    stat=gameConfBase;
                }
            }
            else{
                if(step>=stat.cost){
                    step-=stat.cost;
                    step_arr[state]={};
                    var len,key,i;
                    for(key in {good:1,bad:1}){
                        len=mt_rand(stat[key+"_min"],stat[key+"_max"]);
                        step_arr[state][key]=len;
                        gameState[key+"_all"]+=len;
                        if(key=="good"){
                            gameState.good_max+=len*10;
                            
                        }
                    }
                    stat=0;
                }
            }
        }
        var state_max=state;
        state=0;
        _moduleTimeHandler.set(gameIndex,function(){
            state+=1;
            if(typeof step_arr[state]!="undefined"){
                var obj=step_arr[state];
                var len,key,i;
                for(key in {good:1,bad:1}){
                    len=obj[key];
                    for(i=0;i<len;i++){
                        gameCanvas.startGirlAnim("addCollisionPath",girl_center,key);
                    }

                }
            }
            if(state>state_max){
                _moduleTimeHandler.clear(gameIndex);
            }
        },100);
    }
    function startGame(){
        main.find(".cellBig.girlsSet").animate({"left":"-=200"},300);
        main.find(".arrowView.arrQuest8,#girl_extend").hide();
        var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner");
        toHide.animate({"bottom":"-=100"},300);
        _moduleEvents.on("moduleClear",function(){
            toHide.removeAttr("style");
        });
        gameCell.show();
        gameCell.find(".textfill").textfill();
        
        main.addClass("gameIsReadyJS");
        main.find(".showOnGameJS").show();
        main.find(".hideOnGameJS").css("opacity",0);
        
        ghostCanvas.myArcCanvas(pointsGame,_moduleTimeHandler,_moduleEvents,{"top":115,"left":19});
        
        var img_arr={
            "heart":"/gfx/place/girls/anim/heart.png",
            "puffw":"/gfx/place/girls/ninja/puffwhite.png",
            "puffb":"/gfx/place/girls/ninja/puffblack.png",
        },i;
        for(i=1;i<5;i++){
            img_arr[("good"+i)]="/gfx/place/girls/ninja/good"+i+".png";
            img_arr[("bad"+i)]="/gfx/place/girls/ninja/bad"+i+".png";
        }
//        gameState={good:0,bad:0,happy:0,step:100};
        var animIndex={"red":_moduleTimeHandler.getNewIndex(),"white":_moduleTimeHandler.getNewIndex()},
        step=0,step_max=100,dir;
        function makeAnim(type){
            
            //animCanvas
            
            
            
            
            if(_moduleTimeHandler.isIndexSet(animIndex.red)){
                return false;
            }
            if(type=="white" && _moduleTimeHandler.isIndexSet(animIndex.white)){
                return false;
            }
            if(type=="red" && _moduleTimeHandler.isIndexSet(animIndex.white)){
                _moduleTimeHandler.clear(animIndex.white);
            }
            step=0;
            dir=15;
            var obj=main.find("#girl:visible .img."+type);
            _moduleTimeHandler.set(animIndex[type],function(){
                step+=dir;
                if(step<0){
                    _moduleTimeHandler.clear(animIndex[type]);
                }
                else{
                    if(step>=step_max){
                        step=step_max;
                        dir=dir*(-1);
                    }
                    obj.css("opacity",step/step_max);
                }
            },40,function(){
               obj.css("opacity",0); 
            });
        }
        var last_change=mt_rand(-300,300);
        gameCanvas.on("collisionEvent",function(e,data){
            if(data.eventType=="minus"){
                _mySound.playSound("game_cut_good_word");
                animCanvas.startGirlAnim("addText",_LANGS["GIRLS-TPL_GAMEIN_CUT_GOOD"],[data.imgPos[0],780-data.imgPos[1]],"#465f13",20,"#ffffff",5,20);
            }
            if(data.eventType=="add"){
                _mySound.playSound("game_cut_bad_word");
                animCanvas.startGirlAnim("addText",_LANGS["GIRLS-TPL_GAMEIN_CUT_BAD"],[data.imgPos[0],780-data.imgPos[1]],"#ff0000",20,"#ffffff",30,20);
            }
            gameState.ended_all++;
            gameCheckEnd();
    
        }).on("moveEnd",function(e,data){
            if(data.eventType=="add"){
                gameState.good++;
                gameState.happy+=10;
                makeAnim("white");
                var end_pos=copyArray(data.imgPos);
                last_change+=450;
                last_change=last_change%600-300;
                end_pos[0]+=last_change;
                end_pos[1]-=820;
                _mySound.playSound("game_success");
                animCanvas.startGirlAnim("addAnimCustom",data.imgPos,end_pos,"heart",50,[50,40]);
                
            }
            if(data.eventType=="minus"){
                gameState.bad++;
                gameState.happy=Math.ceil(gameState.happy/2);
                makeAnim("red");
                var end_pos=copyArray(data.imgPos);
                end_pos[0]+=mt_rand(-200,200);
                end_pos[1]+=820;
                _mySound.playSound("game_bad_word_reach");
                animCanvas.startGirlAnim("addAnimCustom",data.imgPos,end_pos,"heart_broken",100,[80,60]);
            }
            gameState.ended_all++;
            gameView();
            gameCheckEnd();
        }).one("was_loaded",function(){
            _timerManager.addTimer("#gameCellJS .timerTimesJS",time_end,1);
            gameDuring();
            gameCanvas.startGirlAnim("setCollisionPoint",pointsGame);
            
        }).startGirlAnim({
            load_images:img_arr,
            collision_easy:1
        },_moduleTimeHandler);
        
        
//        gameCanvas
        
        var time_end=getCurrentTime()+gameHowlong;
        gameCell.find(".fillTimesJS").beltTimer(0,gameHowlong,time_end,{
            on_end_timer:function(){
                
            }
        },_moduleTimeHandler);
        
        var body=$("body");
        body.addClass("noselect");
        _moduleEvents.one("moduleClear",function(){
           body.removeClass("noselect"); 
        });
        
    }
    function gameCheckEnd(){
        if(gameState.ended_all==gameState.good_all+gameState.bad_all){
            var but=gameCell.find("#butEndJS");
            but.append("<div class='arrowView'></div>");
            but.find(".arrowView").myUpDown({'rotation':90,left:-60,top:12});
        }
    }
    function gameView(){
        var happy=Math.floor(gameState.happy/gameState.good_max*game_happy_max);
        
        gameCell.find(".heartNumJS").html(numberFormat(happy));
        gameCell.find(".progressBarJS").animate({height:(gameState.happy/gameState.good_max*100)+"%"},100);
        gameCell.find("#gameOutHeartJS").val(happy);
    }
    function helpAnim(){
        var points=[
            [0,0],
            [51,72],
            [104,138],
            [156,196],
            [207,250]
        ];
        var funArr=new Smooth(points),points_len=points.length,step=0,step_max=100,
        obj=main.find("#helpHintJS"),animIndex=_moduleTimeHandler.getNewIndex(),
        waitIndex=_moduleTimeHandler.getNewIndex();
        
        
        function makeIt(){
            step=0;
            
            obj=main.find("#helpHintJS");
            obj.css({width:"0px",height:"0px"});
            obj.fadeIn(500);
            _moduleTimeHandler.setOne(waitIndex,function(){
                _moduleTimeHandler.set(animIndex,function(){
                    
                    step+=12;
                    if(step>step_max*(points_len-1)){
                        step=step_max*(points_len-1);
                        _moduleTimeHandler.clear(animIndex);
                        _moduleTimeHandler.setOne(waitIndex,function(){
                            makeIt();
                        },550);
                        obj.fadeOut(500);
                    }
                    var point=funArr(step/step_max),
                    set_it={width:(Math.floor(point[0])+"px"),height:(Math.floor(point[1])+"px")};
//                    $.qLog(set_it.height+" ");
                    obj.css(set_it);
                    
                    
                },40);
            },550);
            
        }
        makeIt();
    }
    function initStart(){
        book.show();
        var tmp=book.find(">.content");
        startCanvas.add(startImgCanvas).attr({width:tmp.width(),height:tmp.height()});
        startCanvas.myArcCanvas(pointsStart,_moduleTimeHandler,_moduleEvents,{"top":298,"left":354});
        var cutImg=book.find("#cutItNowJS"),bookOff=startImgCanvas.offset(),imgOff=cutImg.offset();
        var canvasPos=[imgOff.left-bookOff.left+cutImg.width()/2,imgOff.top-bookOff.top+cutImg.height()/2];//
        canvasPos=[444,250]//jsquery bug workaround;
        startImgCanvas.on("collisionEvent",function(e,coll){
            book.bookUse("hide");
            _moduleTimeHandler.clear(startIndex);
            _mySound.playSound("game_cut_good_word");
            startGame();
        }).one("was_loaded",function(){
            startImgCanvas.startGirlAnim("addCollisionStart",canvasPos);
            startImgCanvas.startGirlAnim("setCollisionPoint",pointsStart);
        }).startGirlAnim({
            load_images:{
                "bad1":"/gfx/place/girls/ninja/bad1.png"
            },
        },_moduleTimeHandler);
        helpAnim();
        
        book.find(".textfill").textfill();
        book.hide();
//        startImgCanvas.trigger("collisionEvent")
    }
    function initGame(){
        gameCanvas.add(ghostCanvas).attr({width:main.width(),height:main.height()});
    }
    function init(){
        initStart();
        initGame();
        
    }
    init();
    book.on("open",function(){
        var girl=main.find("#girl:visible");
        if(girl.find(".img.red").length==0){
            girl.append(
                "<div class='img red' style='background-image:url("+_IMG_SERV+"/gfx/girls/"+$.takeGirlImage(girlData.girl_id)+"/position/ready/"+girlData.level+"_red.png"+$.takeGirlVersion(girlData.girl_id)+")'></div>"+
                "<div class='img white' style='background-image:url("+_IMG_SERV+"/gfx/girls/"+$.takeGirlImage(girlData.girl_id)+"/position/ready/"+girlData.level+"_light.png"+$.takeGirlVersion(girlData.girl_id)+")'></div>"
            );
        }
       
    });
//    book.bookUse("show");
//    startGame();
}